export default {
  getGreennProfit: (state) => state.activeProfit,
  getLoadingSettings: (state) => state.loadingSettings,
  getLoadingQuestions: (state) => state.loadingQuestions,
  getDefaultSettings: (state) => state.defaultSettings,
  getOpportunitiesSettings: (state) => state.opportunitiesSettings,
  getOpportunitiesQuestionsAnswers: (state) => state.opportunitiesQuestionsAnswers
};